import { render, staticRenderFns } from "./DiscCaseMainArt.vue?vue&type=template&id=c5f0845e&"
import script from "./DiscCaseMainArt.vue?vue&type=script&lang=js&"
export * from "./DiscCaseMainArt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
